type PreferenceOption = "granted" | "denied"

interface GPCNavigator extends Navigator {
  globalPrivacyControl?: boolean
}

declare let navigator: GPCNavigator

interface CookieConsentPreferences {
  ad_user_data: PreferenceOption
  ad_personalization: PreferenceOption
  ad_storage: PreferenceOption
  analytics_storage: PreferenceOption
  functional_storage: PreferenceOption
  personalization_storage: PreferenceOption
  security_storage: PreferenceOption
}

export const defaultCookieConsentPreferences: CookieConsentPreferences = {
  ad_user_data: "denied",
  ad_personalization: "denied",
  ad_storage: "denied",
  analytics_storage: "denied",
  functional_storage: "denied",
  personalization_storage: "denied",
  security_storage: "granted",
}

const gpc = navigator.globalPrivacyControl

export const gpcSignal = gpc === true || gpc === false ? gpc : null

export default function getCookieConsentPreferences() {
  const rawPreferenceCookie = document.cookie
    .split(";")
    .find(c => c.includes("ca_mktg_cookie_consent_prefs"))

  const cookieConsentPreferences = rawPreferenceCookie
    ? (JSON.parse(
        decodeURIComponent(rawPreferenceCookie.trim().split("=")[1]),
      ) as CookieConsentPreferences)
    : undefined

  return cookieConsentPreferences
}
